import { render, staticRenderFns } from "./Empresa-tab-dados-complementares.vue?vue&type=template&id=0a86df51&scoped=true&"
import script from "./Empresa-tab-dados-complementares.vue?vue&type=script&lang=js&"
export * from "./Empresa-tab-dados-complementares.vue?vue&type=script&lang=js&"
import style0 from "./Empresa-tab-dados-complementares.vue?vue&type=style&index=0&id=0a86df51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86df51",
  null
  
)

export default component.exports